import { render, staticRenderFns } from "./PurchaseDuoSalesOrders.vue?vue&type=template&id=6abe94b4&"
import script from "./PurchaseDuoSalesOrders.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoSalesOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports